import { FunctionComponent } from "react";
import { IonButton, IonIcon } from "@ionic/react";

interface EditActionButtonProps {
  onClick: () => void;
  icon: string;
  label: string;
  color: string;
  disabled?: boolean;
}

export const EditActionButton: FunctionComponent<EditActionButtonProps> = ({
  onClick,
  icon,
  label,
  color,
  disabled = false,
}) => (
  <IonButton
    role="button"
    color={color}
    fill={"solid"}
    expand={"block"}
    disabled={disabled}
    style={{
      flexGrow: 1,
      boxShadow:
        "0px 4px 10px rgba(141, 159, 172, 0.15), 0px 10px 42px rgba(141, 159, 172, 0.18), 0px 4px 4px -4px rgba(141, 159, 172, 0.16)",
    }}
    onClick={onClick}
  >
    <IonIcon slot="start" icon={icon} />
    {label}
  </IonButton>
);
